/* ═══════════════════════════════════════════════════════
   NEWJAISA — COMPANY PAGE JAVASCRIPT
   File: assets/company.js
   All functions prefixed co- to prevent conflicts
═══════════════════════════════════════════════════════ */

/* ── TABS ─────────────────────────────────────────── */
function coOpenTab(name) {
  // Deactivate all panels and buttons
  document.querySelectorAll('.co-tab-panel').forEach(function(p) {
    p.classList.remove('active');
  });
  document.querySelectorAll('.co-tab-btn').forEach(function(b) {
    b.classList.remove('active');
    b.setAttribute('aria-selected', 'false');
  });

  // Activate target panel
  var panel = document.getElementById('co-tab-' + name);
  if (panel) panel.classList.add('active');

  // Activate matching tab button
  var buttons = document.querySelectorAll('.co-tab-btn');
  for (var i = 0; i < buttons.length; i++) {
    if (buttons[i].getAttribute('aria-controls') === 'co-tab-' + name) {
      buttons[i].classList.add('active');
      buttons[i].setAttribute('aria-selected', 'true');
      break;
    }
  }

  // Smooth scroll to tabs bar (accounting for topbar height)
  var tabsBar = document.getElementById('co-tabs-bar');
  if (tabsBar) {
    var offset = tabsBar.getBoundingClientRect().top + window.pageYOffset - 62;
    window.scrollTo({ top: offset, behavior: 'smooth' });
  }

  // Re-run reveal for newly visible panel
  coObserveReveals();
}

/* ── SCROLL REVEAL ────────────────────────────────── */
function coObserveReveals() {
  var revealEls = document.querySelectorAll('.co-reveal:not(.co-visible)');

  if (!('IntersectionObserver' in window)) {
    // Fallback: show all immediately if no IntersectionObserver support
    revealEls.forEach(function(el) {
      el.classList.add('co-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('co-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -40px 0px'
  });

  revealEls.forEach(function(el) {
    observer.observe(el);
  });
}

/* ── STICKY TABS OFFSET ──────────────────────────── */
function coUpdateTabsOffset() {
  var topbar = document.querySelector('.co-topbar');
  var tabsBar = document.querySelector('.co-tabs-bar');
  if (topbar && tabsBar) {
    tabsBar.style.top = topbar.offsetHeight + 'px';
  }
}

/* ── HASH-BASED TAB ROUTING ─────────────────────── */
function coHandleHash() {
  var hash = window.location.hash;
  if (hash && hash.indexOf('#co-tab-') === 0) {
    var name = hash.replace('#co-tab-', '');
    var validTabs = ['about', 'team', 'infra', 'trust', 'investors', 'careers'];
    if (validTabs.indexOf(name) !== -1) {
      coOpenTab(name);
    }
  }
}

/* ── MOBILE TABS: SCROLL ACTIVE INTO VIEW ───────── */
function coScrollTabIntoView(btn) {
  if (btn && btn.scrollIntoView) {
    btn.scrollIntoView({ inline: 'center', behavior: 'smooth', block: 'nearest' });
  }
}

/* ── INIT ─────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function() {
  // Run reveal on initial load
  coObserveReveals();

  // Update tabs sticky offset
  coUpdateTabsOffset();
  window.addEventListener('resize', coUpdateTabsOffset);

  // Handle deep link via hash (e.g. /pages/company#co-tab-trust)
  coHandleHash();

  // Scroll active tab button into view on tab switch
  document.querySelectorAll('.co-tab-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      coScrollTabIntoView(btn);
    });
  });

  // Ensure first active panel reveals are triggered
  var activePanel = document.querySelector('.co-tab-panel.active');
  if (activePanel) {
    var els = activePanel.querySelectorAll('.co-reveal:not(.co-visible)');
    els.forEach(function(el) { el.classList.add('co-visible'); });
  }
});

//++++++++++++++++++Redirect to BFSI to Company Tabs Specs
document.addEventListener("DOMContentLoaded", function () {
  const params = new URLSearchParams(window.location.search);
  const tab = params.get("tab");

  if (tab) {
    if (typeof coOpenTab === "function") {
      coOpenTab(tab);
    }
  }
});
